module.exports = __webpack_public_path__ + "img/box.ef511230.svg";